import { convertOldBaseTextProps } from '../text/converter.old';
import type { OldBaseTextProps } from '../text/converter.old';
import { convertOldTooltipProps } from '../tooltip/converter.old';
import type { OldTooltipProps } from '../tooltip/converter.old';
import type { CopyTextProps } from './CopyText';

export interface OldCopyTextProps extends Omit<CopyTextProps, 'textProps' | 'tooltipProps'> {
  textProps?: OldBaseTextProps;
  tooltipProps?: Omit<OldTooltipProps, 'children'>;
}

function convertOldCopyTextTooltipProps(
  props: Omit<OldTooltipProps, 'children'>,
): NonNullable<CopyTextProps['tooltipProps']> {
  const { children: _children, ...convertedProps } = convertOldTooltipProps({ ...props, children: null });

  return convertedProps;
}

export function convertOldCopyTextProps(props: OldCopyTextProps): CopyTextProps {
  const { textProps, tooltipProps, ...restProps } = props;

  return {
    ...restProps,
    textProps: textProps ? convertOldBaseTextProps(textProps) : undefined,
    tooltipProps: tooltipProps ? convertOldCopyTextTooltipProps(tooltipProps) : undefined,
  };
}
